import { fansupportPublic } from "../index"

export const getDocument = async ({ type }) => {
    return fansupportPublic.get('/document', {params: {
        type,
    }})
}